import { Select } from 'antd'
import { type ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { AgentApprovalPolicy } from './approvalMode'

/**
 * 入力欄の下の、承認モードの選択（仕様の「入力欄の操作」）。選んだものは呼び出し側（AgentWidget）が持ち、ブラウザに覚える（approvalMode.ts）
 */
export const ApprovalPolicySelect = ({
  value,
  onChange,
}: {
  value: AgentApprovalPolicy
  onChange: (approvalPolicy: AgentApprovalPolicy) => void
}): ReactElement => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    // 選択肢を開いている間の Esc は、選択肢だけを閉じ、枠の Esc（入口に戻す）まで伝えない。一番上に開いているものから閉じるため
    <div
      data-e2e="agent-approval-policy"
      onKeyDown={(event) => {
        if (isOpen && event.key === 'Escape') {
          event.stopPropagation()
        }
      }}
    >
      <Select<AgentApprovalPolicy>
        size="small"
        variant="borderless"
        popupMatchSelectWidth={false}
        aria-label={t(`承認モード`)}
        value={value}
        open={isOpen}
        onOpenChange={setIsOpen}
        options={[
          { value: 'on-request', label: t(`確認してから反映`) },
          { value: 'never', label: t(`自動で反映`) },
        ]}
        onChange={onChange}
      />
    </div>
  )
}
